import register_1 from '../../assets/images/documentation/registeration/register_1.png';
import register_2 from '../../assets/images/documentation/registeration/register_2.png';
import register_3 from '../../assets/images/documentation/registeration/register_3.png';
import register_4 from '../../assets/images/documentation/registeration/regitser_4.png';
import exam_manager_1 from '../../assets/images/documentation/exam_section/exam_manager_1.png';
import exam_manager_2 from '../../assets/images/documentation/exam_section/exam_manager_2.png';
import exam_manager_3 from '../../assets/images/documentation/exam_section/exam_manager_3.png';
import exam_manager_4 from '../../assets/images/documentation/exam_section/exam_manager_4.png';
import exam_manager_5 from '../../assets/images/documentation/exam_section/exam_manager_5.png';
import exam_manager_6 from '../../assets/images/documentation/exam_section/exam_manager_6.png';
import dashboard_img from '../../assets/images/documentation/dashboard.png';
import course_1 from '../../assets/images/documentation/courses_section/course_1.png';
import course_2 from '../../assets/images/documentation/courses_section/course_2.png';
import blog_1 from '../../assets/images/documentation/blog_section/blog_1.png';
import student_1 from '../../assets/images/documentation/student_section/student_1.png';
import student_2 from '../../assets/images/documentation/student_section/student_2.png';
import student_3 from '../../assets/images/documentation/student_section/student_3.png';
import student_4 from '../../assets/images/documentation/student_section/student_4.png';
import student_5 from '../../assets/images/documentation/student_section/student_5.png';
import mozakara_1 from '../../assets/images/documentation/mozakara_section/mozakara_1.png';
import mozakara_2 from '../../assets/images/documentation/mozakara_section/mozakara_2.png';
import report_1 from '../../assets/images/documentation/report_section/report_1.png';
import report_2 from '../../assets/images/documentation/report_section/report_2.png';
import report_3 from '../../assets/images/documentation/report_section/report_3.png';
import setting_1 from '../../assets/images/documentation/setting_section/setting_1.png';
import profile_1 from '../../assets/images/profile_section/profile_1.png';
import profile_2 from '../../assets/images/profile_section/profile_2.png';

const ar = [
  {
    id: "registration",
    title: "تسجيل حساب معلم (Teacher Registration)",
    description: "دليل خطوة بخطوة لإنشاء حساب معلم جديد على منصة امتحاني، بدءاً من إدخال البيانات الأساسية وحتى تفعيل الحساب.",
    icon: "faUser",
    actions: [
      {
        title: "1. 👤 البيانات الأساسية",
        type: "success",
        steps: [
          "📝 قم بملء بياناتك الأساسية: الاسم بالكامل، البريد الإلكتروني، رقم الهاتف، والنوع.",
          "🔒 أدخل كلمة مرور قوية (تحتوي على حروف كبيرة وصغيرة وأرقام) وقم بتأكيدها.",
          "[IMG]" + register_1,
          "▶️ انقر على 'التالي' للانتقال إلى الخطوة التالية."
        ]
      },
      {
        title: "2. 🎓 البيانات الأكاديمية",
        type: "info",
        steps: [
          "📜 أدخل مؤهلك العلمي (مثال: بكالوريوس تربية).",
          "📚 اختر المادة التي تدرسها من القائمة المنسدلة.",
          "🏫 حدد الصفوف الدراسية التي تقوم بالتدريس لها (يمكنك اختيار أكثر من صف).",
          "✍️ اكتب نبذة مختصرة عنك (اختياري).",
          "[IMG]" + register_2,
          "▶️ انقر على 'التالي' للاستمرار."
        ]
      },
      {
        title: "3. 🖼️ الصورة الشخصية",
        type: "info",
        steps: [
          "📸 يمكنك رفع صورة شخصية احترافية لتظهر لطلابك على المنصة (هذه الخطوة اختيارية).",
          "[IMG]" + register_3,
          "✅ انقر على 'إتمام التسجيل' لإرسال طلبك."
        ]
      },
      {
        title: "4. 🔐 تفعيل الحساب (OTP)",
        type: "warning",
        steps: [
          "📲 بعد إتمام التسجيل، سيتم توجيهك إلى صفحة تفعيل الحساب.",
          "📩 ستصلك رسالة تحتوي على كود التفعيل (OTP) عبر الواتساب أو رسالة نصية قصيرة.",
          "🔑 أدخل الكود المكون من 6 أرقام في الخانات المخصصة.",
          "[IMG]" + register_4,
          "🎉 انقر على 'تأكيد' لتفعيل حسابك والبدء في استخدام المنصة."
        ]
      }
    ],
    screenshotId: register_1
  },
  {
    id: "dashboard",
    title: "لوحة التحكم (Dashboard)",
    description: "النظرة العامة لحساب المعلم، حيث يمكنك رؤية إحصائيات سريعة ومتابعة الإشعارات.",
    icon: "faChartBar",
    actions: [
      {
        title: "📊 عرض الإحصائيات السريعة",
        type: "info",
        steps: [
          "🔐 قم بتسجيل الدخول إلى حساب المعلم الخاص بك.",
          "📈 في الصفحة الرئيسية (لوحة التحكم)، ستجد بطاقات علوية تعرض إجمالي الامتحانات، عدد الطلاب، والإيرادات.",
          "👆 يمكنك النقر على أي من هذه البطاقات للانتقال إلى التفاصيل الخاصة بها لمعرفة المزيد."
        ]
      },
      {
        title: "🔔 متابعة الإشعارات",
        type: "info",
        steps: [
          "🔔 انقر على أيقونة الجرس في الزاوية العلوية لفتح لوحة الإشعارات.",
          "📜 ستظهر قائمة منسدلة بأحدث الإشعارات (مثل تسجيل طالب جديد أو اشتراك في دورة).",
          "🖱️ انقر على الإشعار للانتقال مباشرة إلى الصفحة المعنية ومتابعة الحدث."
        ]
      }
    ],
    screenshotId: dashboard_img
  },
  {
    id: "exam_management",
    title: "إدارة الامتحانات (Exam Management)",
    description: "القسم الشامل لإنشاء، تعديل، وإدارة الامتحانات بشكل كامل. يتضمن هذا القسم ميزات متقدمة مثل تخصيص الامتحانات، متابعة حالة الطلاب، طباعة الامتحانات، وإرسال النتائج لأولياء الأمور.",
    icon: "faFileAlt",
    actions: [
      {
        title: "1. 📝 إنشاء امتحان جديد (إعدادات أساسية ومتقدمة)",
        type: "success",
        steps: [
          "📂 من القائمة الجانبية، اختر 'الامتحانات' (Exams).",
          "➕ انقر على زر 'إنشاء امتحان جديد' (أيقونة +) أعلى يسار الشاشة للبدء.",
          "✍️ في النافذة المنبثقة، قم بإدخال 'عنوان الامتحان' ووصف قصير للامتحان.",
          "🏫 حدد 'الصف الدراسي' (Class) من القائمة المنسدلة.",
          "[IMG]" + exam_manager_3,
          "📅 حدد 'تاريخ ووقت بدء الامتحان' وتأكد من صحة التوقيت.",
          "⏱️ أدخل 'مدة الامتحان بالدقائق' (Exam Duration).",
          "⚖️ حدد 'وزن السؤال' (Question Weight) الافتراضي الذي سيتم تطبيقه على الأسئلة.",
          "⚙️ الإعدادات المتقدمة: يمكنك تفعيل خيار 'الترتيب العشوائي للأسئلة' لمنع الغش، وتفعيل 'استخدام المسودة' ليتمكن الطالب من الكتابة أثناء الامتحان.",
          "💾 انقر على 'حفظ' (Save). سيظهر الامتحان في قائمة الامتحانات بحالة 'قيد الانتظار' أو 'غير مكتمل'."
        ],
        warning: "⚠️ تأكد من ضبط مدة الامتحان ووزن السؤال بعناية، حيث سيؤثر ذلك مباشرة على التقييم النهائي للطالب."
      },
      {
        title: "2. ❓ إدارة أسئلة الامتحان",
        type: "info",
        steps: [
          "📋 في قائمة الامتحانات، انقر على اسم الامتحان أو زر 'التفاصيل' للدخول إلى شاشة إدارة الأسئلة.",
          "➕ انقر على 'إضافة سؤال جديد'، وقم بتحديد نوع السؤال (اختيار من متعدد، نصي، الخ).",
          "✍️ قم بكتابة نص السؤال وأضف الخيارات الممكنة، ثم حدد الإجابة الصحيحة.",
          "[IMG]" + exam_manager_2,
          "✅ بعد الانتهاء من إضافة كافة الأسئلة، قم بمراجعة إجمالي الدرجات ليتطابق مع ما خططت له."
        ]
      },
      {
        title: "3. ▶️ بدء، إيقاف، أو إعادة تعيين الامتحان",
        type: "warning",
        steps: [
          "▶️ لبدء الامتحان: ابحث عن الامتحان وانقر على زر 'بدء الامتحان' (أيقونة ▶️). سيصبح الامتحان متاحاً للطلاب.",
          "[IMG]" + exam_manager_4,
          "⏹️ لإيقاف الامتحان: انقر على زر 'إيقاف' (أيقونة ⏹️). لن يتمكن أي طالب جديد من الدخول، وسيتم تسليم إجابات الطلاب المتواجدين.",
          "🔄 لإعادة التعيين: انقر على زر 'إعادة تعيين' (أيقونة 🔄). ستظهر لك رسالة تحذيرية لتأكيد مسح كافة المحاولات."
        ],
        warning: "🚨 إعادة تعيين الامتحان (Reset) تؤدي إلى مسح كافة إجابات ودرجات الطلاب المسجلة لهذا الامتحان. استخدم هذا الخيار بحذر شديد!"
      },
      {
        title: "4. 👤 تخصيص الامتحان لطالب معين",
        type: "success",
        steps: [
          "👥 إذا أردت أن يقوم طالب محدد فقط بأداء الامتحان، انقر على أيقونة 'تخصيص' بجوار الامتحان.",
          "🪟 ستظهر لك نافذة منبثقة تحتوي على قائمة بطلابك.",
          "🔍 ابحث عن اسم الطالب، حدده، ثم انقر على 'تأكيد التخصيص'.",
          "🔒 لن يظهر هذا الامتحان إلا للطالب الذي تم تخصيصه له فقط."
        ]
      },
      {
        title: "5. ✈️ إرسال النتائج لأولياء الأمور",
        type: "info",
        steps: [
          "📊 بعد انتهاء الامتحان وتصحيحه، يمكنك إرسال النتائج مباشرة لأولياء الأمور.",
          "✈️ انقر على أيقونة 'إرسال لأولياء الأمور' (أيقونة الطائرة الورقية ✈️).",
          "[IMG]" + exam_manager_5,
          "📱 سيتم إرسال إشعارات و/أو رسائل SMS لأولياء أمور الطلاب بنتيجة أبنائهم."
        ]
      },
      {
        title: "6. 🖨️ طباعة الامتحان الورقي",
        type: "info",
        steps: [
          "📄 إذا كنت تفضل إجراء امتحان ورقي، توفر لك المنصة خيار الطباعة المباشرة.",
          "🖨️ انقر على أيقونة 'الطباعة' (🖨️) بجوار الامتحان المطلوب.",
          "📑 سيقوم النظام بتوليد ملف جاهز للطباعة يحتوي على كافة الأسئلة بشكل منسق.",
          "[IMG]" + exam_manager_6
        ]
      },
      {
        title: "7. 📈 متابعة حالة الطلاب (المكتمل وغير المكتمل)",
        type: "info",
        steps: [
          "📊 في القائمة، يمكنك النقر على أيقونات الإحصائيات لمشاهدة القوائم السريعة.",
          "✅ الطلاب الذين أتموا الامتحان: يعرض قائمة بالطلاب الذين أنهوا الامتحان وتم رصد درجاتهم.",
          "⏳ الطلاب المتخلفون: يعرض قائمة بالطلاب الذين لم يقوموا بالدخول إلى الامتحان، مما يتيح لك التواصل معهم."
        ]
      },
      {
        title: "8. 🗑️ حذف الامتحان",
        type: "danger",
        steps: [
          "🗑️ إذا أردت حذف امتحان بشكل نهائي، انقر على أيقونة 'الحذف' الحمراء.",
          "⚠️ ستظهر رسالة تأكيد تحذيرية للتأكد من رغبتك في الحذف.",
          "✅ انقر على 'تأكيد الحذف'."
        ],
        warning: "🚨 لا يمكن استرجاع الامتحان أو نتائجه بعد تأكيد الحذف. يرجى التأكد التام قبل اتخاذ هذا الإجراء."
      }
    ],
    screenshotId: exam_manager_1
  },
  {
    id: "course_management",
    title: "إدارة الدورات (Course Management)",
    description: "قسم شامل لإنشاء وتعديل الدورات التدريبية، إدارة الفيديوهات، متابعة اشتراكات الطلاب، ومراجعة طلبات التسجيل.",
    icon: "faBook",
    actions: [
      {
        title: "1. 📚 إنشاء دورة جديدة",
        type: "success",
        steps: [
          "📁 من القائمة الجانبية، اختر 'الدورات' (Courses).",
          "➕ انقر على زر 'إضافة دورة جديدة' (أيقونة +) أعلى يسار الشاشة.",
          "✍️ قم بتعبئة بيانات الدورة الأساسية: اسم الدورة، الوصف، السعر، ونسبة الخصم (إن وجدت).",
          "🏫 حدد القسم (Category) والمادة الدراسية (Material) من القوائم المنسدلة.",
          "🎓 حدد ما إذا كانت الدورة 'معتمدة' (Certified) أم لا.",
          "🖼️ قم برفع 'صورة غلاف' مميزة للدورة لجذب الطلاب.",
          "💾 انقر على 'حفظ'. بمجرد الحفظ، ستظهر الدورة في شبكة الدورات."
        ]
      },
      {
        title: "2. 🎥 إدارة فيديوهات الدورة ورفعها",
        type: "info",
        steps: [
          "🎥 في شبكة الدورات، ابحث عن الدورة وانقر على أيقونة 'الفيديو' الخاصة بها للدخول إلى شاشة إدارة الفيديوهات.",
          "📑 ستجد علامتي تبويب: 'مكتبة الفيديوهات' لعرض الفيديوهات الحالية، و'رفع فيديوهات جديدة'.",
          "☁️ لرفع فيديو جديد: انتقل إلى تبويب الرفع، وأدخل 'عنوان/وصف الفيديو'. يمكنك سحب وإفلات ملف الفيديو أو النقر لاختياره (بحد أقصى 500MB لكل فيديو).",
          "➕ يمكنك رفع عدة فيديوهات في نفس الوقت بالنقر على 'إضافة فيديو آخر' ثم بدء الرفع.",
          "✋ ترتيب الفيديوهات بالسحب والإفلات: في مكتبة الفيديوهات، يمكنك سحب أي فيديو من أيقونة السحب (Drag Handle) وإفلاته بالترتيب المطلوب، ثم النقر على زر 'حفظ الترتيب' لأرشفة الترتيب للطلاب.",
          "[IMG]" + course_2,
          "📼 في 'مكتبة الفيديوهات': يمكنك مشاهدة الفيديوهات المرفوعة ومعرفة مساحتها الإجمالية والتحكم الكامل بكل فيديو."
        ]
      },
      {
        title: "3. ❓ الأسئلة التفاعلية والكويزات على الفيديو",
        type: "success",
        steps: [
          "➕ إضافة سؤال تفاعلي: انقر على أيقونة 'إضافة سؤال' (+) المخصصة للفيديو لإضافة سؤال يظهر للطلاب تلقائياً عند دقيقة وثانية محددة (Timestamp بالثواني).",
          "🎯 أدخل نص السؤال، الشرح/التفسير، 4 خيارات، حدد الإجابة الصحيحة، ودرجة السؤال.",
          "📋 عرض وإدارة الكويزات: انقر على أيقونة 'عرض الأسئلة والكويزات' (أيقونة القائمة) لمراجعة كافة الأسئلة التفاعلية المرتبطة بالفيديو أو تعديلها أو حذفها."
        ]
      },
      {
        title: "4. 📎 مرفقات الفيديوهات والمستندات",
        type: "info",
        steps: [
          "📎 إضافة مرفق: انقر على أيقونة 'إضافة مرفق' (أيقونة الدبوس) لرفع ملخصات PDF أو مستندات أو صور داعمة للفيديو.",
          "📂 عرض وإدارة المرفقات: انقر على أيقونة 'عرض المرفقات' (أيقونة المجلد) لمشاهدة الملفات المرفقة بالفيديو وتنزيلها أو حذفها."
        ]
      },
      {
        title: "5. 🔄 تعديل وصف الفيديو وتحديث ملف الفيديو",
        type: "warning",
        steps: [
          "✏️ تعديل وصف الفيديو: انقر على أيقونة 'التعديل' (أيقونة القلم) لتحديث عنوان أو وصف الفيديو في أي وقت.",
          "🔄 تحديث ملف الفيديو: انقر على أيقونة 'التحديث' (أيقونة المزامنة) لاستبدال ملف الفيديو بملف آخر جديد بدقة أفضل دون مسح أسئلته أو مرفقاته.",
          "🗑️ حذف الفيديو: انقر على أيقونة سلة المهملات لإزالة الفيديو نهائياً بعد التأكيد."
        ]
      },
      {
        title: "6. 👁️ إظهار وإخفاء الدورة (الرؤية)",
        type: "warning",
        steps: [
          "👁️‍🗨️ يمكنك التحكم في ظهور الدورة للطلاب.",
          "👁️ انقر على أيقونة 'العين' بجوار الدورة لإخفائها مؤقتاً أو إعادة إظهارها.",
          "🚫 الدورات المخفية لن تظهر في متجر الدورات للطلاب."
        ]
      },
      {
        title: "7. 🧮 إعادة حساب ساعات الدورة",
        type: "info",
        steps: [
          "⏳ إذا قمت بإضافة أو إزالة فيديوهات من الدورة، يمكنك تحديث إجمالي عدد الساعات المسجلة.",
          "🧮 انقر على زر 'إعادة حساب الساعات' الموجود في بطاقة الدورة.",
          "✅ سيقوم النظام تلقائياً بتحديث الوقت الإجمالي وعرضه للطلاب."
        ]
      },
      {
        title: "8. 👥 إدارة الاشتراكات وطلبات التسجيل",
        type: "success",
        steps: [
          "📑 استخدم علامات التبويب العلوية للتبديل بين 'الدورات'، 'الاشتراكات'، و'طلبات التسجيل'.",
          "💳 في قسم 'الاشتراكات': يمكنك رؤية الطلاب المشتركين حالياً في دوراتك وإدارة اشتراكاتهم.",
          "📬 في قسم 'طلبات التسجيل': يمكنك مراجعة طلبات الطلاب الذين يرغبون في الانضمام لدورة معينة والموافقة عليها أو رفضها."
        ]
      },
      {
        title: "9. ✏️ تعديل أو حذف الدورة",
        type: "danger",
        steps: [
          "✏️ لتعديل بيانات الدورة: انقر على أيقونة 'التعديل' وقم بتحديث البيانات (مثل السعر أو الوصف) ثم احفظ التغييرات.",
          "🗑️ لحذف الدورة: انقر على أيقونة 'الحذف' الحمراء.",
          "⚠️ ستظهر لك نافذة تحذيرية لتأكيد الحذف. تأكد من قرارك لأن الحذف نهائي."
        ],
        warning: "🚨 حذف الدورة سيؤدي إلى فقدان محتواها بالكامل. ينصح باستخدام ميزة 'الإخفاء' بدلاً من الحذف إذا كان هناك طلاب مشتركون."
      }
    ],
    screenshotId: course_1
  },
  {
    id: "blog_management",
    title: "إدارة المقالات (Blog Management)",
    description: "قسم شامل لإضافة، تعديل، وحذف المقالات التعليمية الخاصة بالمنصة مع إمكانية البحث والتصنيف.",
    icon: "faBlog",
    actions: [
      {
        title: "1. 📝 إضافة مقال جديد",
        type: "success",
        steps: [
          "📰 من القائمة الجانبية، انتقل إلى 'المدونة' (Blog).",
          "➕ انقر على زر 'إضافة مقال جديد' أعلى يسار الشاشة.",
          "📂 قم بتحديد 'القسم' (Category) الخاص بالمقال من القائمة المنسدلة.",
          "✍️ أدخل 'عنوان المقال' و'وصف قصير'.",
          "📄 اكتب محتوى المقال بالكامل في حقل 'المحتوى' باستخدام محرر النصوص الغني.",
          "🖼️ قم برفع 'صورة للمقال' لجذب انتباه الطلاب.",
          "🚀 انقر على 'حفظ'. سيتم نشر المقال فوراً ويظهر للطلاب في قسم المدونة."
        ]
      },
      {
        title: "2. 🔍 البحث وتصفح المقالات",
        type: "info",
        steps: [
          "📋 يعرض جدول المقالات جميع المقالات التي قمت بنشرها.",
          "🔍 يمكنك استخدام شريط البحث للبحث عن مقال معين باستخدام عنوانه.",
          "📄 يمكنك تصفح الصفحات المختلفة باستخدام أزرار التنقل (Pagination) في أسفل الجدول."
        ]
      },
      {
        title: "3. 🗑️ تعديل أو حذف مقال",
        type: "danger",
        steps: [
          "✏️ لتعديل مقال: انقر على أيقونة 'التعديل' بجوار المقال، وقم بتحديث بياناته ثم احفظ.",
          "🗑️ لحذف مقال: انقر على أيقونة 'الحذف' الحمراء.",
          "⚠️ ستظهر نافذة تأكيد تسألك عما إذا كنت متأكداً من الحذف. انقر على 'تأكيد' لمسح المقال."
        ],
        warning: "🚨 حذف المقال إجراء نهائي وسيتم مسحه من المنصة بشكل دائم."
      }
    ],
    screenshotId: blog_1
  },
  {
    id: "student_management",
    title: "إدارة الطلاب (Student Management)",
    description: "القسم الشامل لإضافة الطلاب، تعديل بياناتهم، ومتابعة حالاتهم وحساباتهم الخاصة بالمنصة.",
    icon: "faUsers",
    actions: [
      {
        title: "1. 👨‍🎓 إضافة طالب جديد للمنصة",
        type: "success",
        steps: [
          "👥 من القائمة الجانبية، اختر 'الطلاب' (Students).",
          "➕ انقر على زر 'إضافة طالب جديد' أعلى يسار الشاشة.",
          "✍️ قم بتعبئة بيانات الطالب: الاسم بالكامل، البريد الإلكتروني، الصف، والمادة الدراسية.",
          "⚧️ اختر 'النوع' (ذكر/أنثى) وأدخل 'رقم الهاتف' (يجب أن يبدأ بـ 01 ويتكون من 11 رقماً).",
          "🔑 أدخل 'كلمة المرور' الخاصة بالطالب، ويمكنك رفع صورة شخصية اختيارية.",
          "[IMG]" + student_2,
          "✅ انقر على 'إضافة طالب'. سيتم تفعيل حساب الطالب فوراً."
        ]
      },
      {
        title: "2. 🔍 البحث وتصفح قائمة الطلاب",
        type: "info",
        steps: [
          "📋 يعرض جدول الطلاب جميع المسجلين لديك ببياناتهم الأساسية (الاسم، البريد، الهاتف، كلمة المرور).",
          "🔎 يمكنك استخدام شريط البحث للبحث عن أي طالب باستخدام اسمه أو رقم هاتفه.",
          "👁️ يمكنك إظهار أو إخفاء كلمة مرور الطالب بالنقر على أيقونة العين بجوار كلمة المرور."
        ]
      },
      {
        title: "3. 🔗 مشاركة بيانات الطالب",
        type: "info",
        steps: [
          "🔗 لمشاركة بيانات تسجيل الدخول الخاصة بالطالب، انقر على أيقونة 'المشاركة' بجوار اسم الطالب.",
          "[IMG]" + student_3,
          "📋 سيتم نسخ رسالة منسقة تحتوي على اسم المستخدم وكلمة المرور وباقي التفاصيل، ويمكنك إرسالها للطالب مباشرة."
        ]
      },
      {
        title: "4. 🚫 تفعيل أو إيقاف حساب الطالب",
        type: "warning",
        steps: [
          "🛑 يمكنك منع طالب معين من الدخول لحسابه دون حذفه تماماً.",
          "👤 انقر على أيقونة الحالة (تفعيل/إيقاف) بجوار الطالب.",
          "🔒 إذا قمت بإيقاف الحساب، لن يتمكن الطالب من تسجيل الدخول حتى تقوم بتفعيله مرة أخرى."
        ]
      },
      {
        title: "5. ✏️ تعديل أو حذف بيانات طالب",
        type: "danger",
        steps: [
          "✏️ لتعديل البيانات: انقر على أيقونة 'التعديل' وقم بتحديث أي معلومات (مثل تغيير كلمة المرور أو رقم الهاتف).",
          "[IMG]" + student_4,
          "🗑️ لحذف طالب: انقر على أيقونة 'الحذف' الحمراء.",
          "⚠️ تنبيه: سيؤدي حذف الطالب إلى مسح كافة بياناته ونتائجه واشتراكاته بشكل نهائي."
        ],
        warning: "🚨 استخدم ميزة 'إيقاف الحساب' بدلاً من الحذف إذا كنت ترغب في الاحتفاظ ببيانات الطالب ونتائجه السابقة."
      },
      {
        title: "6. 🤖 تفاصيل الطالب والتحليل الذكي (رفيق AI)",
        type: "success",
        steps: [
          "👁️ في جدول الطلاب، انقر على أيقونة 'التفاصيل' بجوار أي طالب للدخول إلى صفحته الشخصية.",
          "🪪 ستعرض لك الصفحة البطاقة التعريفية للطالب بكافة بياناته الأكاديمية والأساسية.",
          "🤖 في أسفل الشاشة، ستجد أيقونة 'الروبوت' الخاصة بالمساعد الذكي (رفيق AI). انقر عليها.",
          "[IMG]" + student_5,
          "📊 وافق على إنشاء التحليل، وسيقوم النظام بتوليد تقرير شامل ذكي لأداء الطالب في الامتحانات.",
          "📲 بمجرد ظهور التقرير، يمكنك النقر على زر 'إرسال التقرير لولي الأمر' لإرساله عبر الواتساب بنقرة واحدة."
        ]
      }
    ],
    screenshotId: student_1
  },
  {
    id: "mozakara_management",
    title: "إدارة المذكرات (Mozakara Management)",
    description: "رفع ومشاركة المذكرات الدراسية (ملفات PDF) مع الطلاب، وإدارة المذكرات السابقة بكل سهولة.",
    icon: "faBookOpen",
    actions: [
      {
        title: "1. 📤 رفع مذكرة جديدة",
        type: "success",
        steps: [
          "📚 اذهب إلى قسم 'المذكرات' من القائمة الجانبية.",
          "➕ انقر على زر 'إضافة مذكرة' أعلى يسار الشاشة.",
          "✍️ قم بإدخال عنوان المذكرة ووصف قصير لها.",
          "🏫 قم بتحديد الصف الدراسي والمادة التي تنتمي إليها المذكرة.",
          "📄 ارفع ملفات المذكرة (يفضل بصيغة PDF) وأضف صورة غلاف مصغرة.",
          "[IMG]" + mozakara_1,
          "💾 انقر على 'حفظ' لتتاح المذكرة للطلاب المسجلين فوراً."
        ]
      },
      {
        title: "2. 🔍 تصفح وإدارة المذكرات الحالية",
        type: "info",
        steps: [
          "📋 في شاشة إدارة المذكرات، يعرض الجدول جميع المذكرات المرفوعة مسبقاً.",
          "📊 يعرض الجدول تفاصيل كل مذكرة: العنوان، الصف، المادة، عدد الملفات المرفقة، وتاريخ الإنشاء.",
          "[IMG]" + mozakara_2,
          "🔎 يمكنك استخدام شريط البحث للعثور على مذكرة معينة بسرعة."
        ]
      },
      {
        title: "3. ✏️ تعديل أو حذف مذكرة",
        type: "danger",
        steps: [
          "✏️ لتعديل البيانات: انقر على أيقونة 'التعديل' لتحديث المرفقات أو البيانات الأساسية للمذكرة.",
          "🗑️ لحذف مذكرة: انقر على أيقونة 'الحذف' الحمراء لإزالتها نهائياً من المنصة.",
          "⚠️ ستظهر لك رسالة تأكيد قبل الحذف، تأكد من قرارك لأن الحذف لا يمكن التراجع عنه."
        ],
        warning: "🚨 تنبيه هام: عند حذف المذكرة، سيتم حذف كافة الملفات والمرفقات المرتبطة بها نهائياً."
      }
    ],
    screenshotId: mozakara_2
  },
  {
    id: "reports",
    title: "التقارير والإحصائيات (Reports & Analytics)",
    description: "لوحة تحكم شاملة لمتابعة أداء الطلاب، تحليل نتائج الاختبارات، واستخراج تقارير مفصلة لاتخاذ قرارات مبنية على البيانات.",
    icon: "faChartLine",
    actions: [
      {
        title: "1. 📊 الإحصائيات العامة والرسوم البيانية",
        type: "info",
        steps: [
          "📈 من القائمة الجانبية، اختر 'التقارير' للوصول إلى لوحة التحكم.",
          "💳 ستجد أعلى الشاشة بطاقات تلخص الأداء العام: إجمالي الاختبارات، عدد الطلاب، متوسط الدرجات، ومعدل الإكمال.",
          "🍩 يعرض المخطط الدائري نسبة الطلاب الناجحين مقابل الراسبين.",
          "📊 يوضح المخطط الشريطي أكثر الطلاب تفوقاً، ويوضح المخطط الخطي تطور عدد الطلاب شهرياً.",
          "[IMG]" + report_1
        ]
      },
      {
        title: "2. 📋 تقارير الاختبارات وتصدير البيانات",
        type: "success",
        steps: [
          "📜 في قسم 'تقارير الاختبارات'، يمكنك رؤية تفاصيل كل اختبار على حدة.",
          "👀 يعرض الجدول: اسم الاختبار، التاريخ، عدد الطلاب، متوسط الدرجات، ومعدل الإكمال.",
          "📥 انقر على زر 'تصدير تقرير الاختبارات' لتحميل البيانات بصيغة CSV أو Excel لمشاركتها أو أرشفتها.",
          "[IMG]" + report_2
        ]
      },
      {
        title: "3. 👨‍🎓 تقارير أداء الطلاب الشاملة",
        type: "warning",
        steps: [
          "🧑‍🏫 في أسفل الشاشة، يوجد جدول مخصص لتقارير الطلاب التفصيلية.",
          "📊 يعرض الجدول إحصائيات كل طالب: عدد الاختبارات التي خضع لها، متوسط درجاته، معدل الإكمال، ومعدل التحسن المستمر.",
          "📥 يمكنك أيضاً تصدير تقرير الطلاب الكامل بصيغة CSV بنقرة واحدة على زر 'تصدير تقرير الطلاب'.",
          "[IMG]" + report_3
        ]
      }
    ],
    screenshotId: report_1
  },
  {
    id: "settings",
    title: "الإعدادات العامة (Settings)",
    description: "ضبط التفضيلات الخاصة بحساب المعلم والامتحانات للتحكم الكامل في سير العملية التعليمية بكل سهولة.",
    icon: "faCog",
    actions: [
      {
        title: "1. ⚙️ إعدادات الاختبارات (Exam Settings)",
        type: "info",
        steps: [
          "🛠️ انتقل إلى 'الإعدادات' من القائمة الجانبية للوصول إلى خيارات التحكم المتاحة.",
          "💯 درجة النجاح الافتراضية (Passing Score): يمكنك تعيين نسبة مئوية (مثلاً 50%) لتعتبر كدرجة نجاح افتراضية لأي امتحان جديد تقوم بإنشائه.",
          "📱 السماح بالأجهزة المحمولة (Mobile Devices): قم بتفعيل أو تعطيل هذا الخيار للسماح للطلاب بأداء الامتحانات من خلال هواتفهم المحمولة.",
          "🏆 عدد اختبارات لوحة الشرف (Honor Board): حدد عدد الاختبارات المطلوبة ليتم تصنيف الطالب وإضافته إلى لوحة الشرف بناءً على تفوقه.",
        ]
      },
      {
        title: "2. 💾 حفظ التغييرات (Save Changes)",
        type: "success",
        steps: [
          "💡 سيظهر زر 'حفظ التغييرات' مفعلاً بمجرد قيامك بتعديل أي إعداد من الإعدادات السابقة.",
          "💾 انقر على 'حفظ التغييرات' في أعلى الشاشة لتطبيق التعديلات الجديدة على النظام مباشرة.",
          "ℹ️ ملاحظة: التغييرات التي يتم إجراؤها هنا سيتم تطبيقها تلقائياً كإعدادات افتراضية لجميع الامتحانات المستقبلية."
        ]
      }
    ],
    screenshotId: setting_1
  },
  {
    id: "profile",
    title: "الملف الشخصي (Profile)",
    description: "استعراض بيانات المعلم وتحديثها، ومتابعة حالة الحساب والاشتراك بكل يسر.",
    icon: "faUser",
    actions: [
      {
        title: "1. 👁️ استعراض بيانات الحساب",
        type: "info",
        steps: [
          "🖼️ من خلال الشاشة الرئيسية للملف الشخصي، يمكنك رؤية صورتك الشخصية، اسمك، والمؤهل الخاص بك.",
          "💳 يعرض القسم الجانبي حالة الحساب (موثق ونشط) بالإضافة إلى تفاصيل اشتراكك والأيام المتبقية في الباقة الحالية.",
          "🔒 من خلال تبويب 'الأمان والخصوصية' يمكنك الاطلاع على إرشادات حماية الحساب الخاص بك.",
          "[IMG]" + profile_1
        ]
      },
      {
        title: "2. ✏️ تعديل وتحديث البيانات الشخصية",
        type: "warning",
        steps: [
          "⚙️ انقر على زر 'تعديل الملف الشخصي' (Edit Profile) في القسم الجانبي الأيسر للانتقال لوضع التعديل.",
          "📸 لتغيير صورتك، انقر على أيقونة الكاميرا التي ستظهر فوق صورتك الحالية واختر صورة جديدة من جهازك.",
          "📝 في تبويب 'المعلومات الأساسية'، قم بتحديث اسمك، بريدك الإلكتروني، ومؤهلك الدراسي.",
          "🔑 لتغيير كلمة المرور، انتقل إلى تبويب 'الأمان والخصوصية' وأدخل كلمة المرور الجديدة (أو اترك الحقل فارغاً إذا لم ترغب بتغييرها).",
          "[IMG]" + profile_2,
          "💾 بعد الانتهاء، انقر على زر 'حفظ' (Save) الأخضر ليتم تحديث بياناتك بشكل آمن."
        ]
      }
    ],
    screenshotId: profile_1
  }
];

const en = [
  {
    id: "registration",
    title: "Teacher Registration",
    description: "A step-by-step guide to creating a new teacher account on EMt7any platform, from entering basic information to account activation.",
    icon: "faUser",
    actions: [
      {
        title: "1. 👤 Basic Information",
        type: "success",
        steps: [
          "📝 Fill in your basic details: Full Name, Email, Phone Number, and Gender.",
          "🔒 Enter a strong password (containing uppercase, lowercase, and numbers) and confirm it.",
          "[IMG]" + register_1,
          "▶️ Click 'Next' to proceed to the next step."
        ]
      },
      {
        title: "2. 🎓 Academic Information",
        type: "info",
        steps: [
          "📜 Enter your academic qualification.",
          "📚 Select the material/subject you teach from the dropdown menu.",
          "🏫 Select the classes you teach (you can select multiple classes).",
          "✍️ Write a brief description about yourself (optional).",
          "[IMG]" + register_2,
          "▶️ Click 'Next' to continue."
        ]
      },
      {
        title: "3. 🖼️ Profile Picture",
        type: "info",
        steps: [
          "📸 You can upload a professional profile picture to be shown to your students on the platform (this step is optional).",
          "[IMG]" + register_3,
          "✅ Click 'Complete Registration' to submit your request."
        ]
      },
      {
        title: "4. 🔐 Account Activation (OTP)",
        type: "warning",
        steps: [
          "📲 After completing the registration, you will be redirected to the account activation page.",
          "📩 You will receive an activation code (OTP) via WhatsApp or SMS.",
          "🔑 Enter the 6-digit code in the designated fields.",
          "[IMG]" + register_4,
          "🎉 Click 'Confirm' to activate your account and start using the platform."
        ]
      }
    ],
    screenshotId: register_1
  },
  {
    id: "dashboard",
    title: "Dashboard",
    description: "An overview of your teacher account, where you can see quick statistics and track notifications.",
    icon: "faChartBar",
    actions: [
      {
        title: "📊 View Quick Statistics",
        type: "info",
        steps: [
          "🔐 Log in to your teacher account.",
          "📈 On the homepage (Dashboard), you will find top cards displaying total exams, number of students, and revenue.",
          "👆 You can click on any of these cards to jump to their respective details for more information."
        ]
      },
      {
        title: "🔔 Track Notifications",
        type: "info",
        steps: [
          "🔔 Click on the bell icon in the top corner to open the notifications panel.",
          "📜 A dropdown list will appear with the latest notifications (e.g., a new student registering or a course subscription).",
          "🖱️ Click on a notification to navigate directly to the relevant page and follow up."
        ]
      }
    ],
    screenshotId: dashboard_img
  },
  {
    id: "exam_management",
    title: "Exam Management",
    description: "A comprehensive section for creating, editing, and managing exams entirely. This section includes advanced features like assigning exams, tracking student statuses, printing exams, and sending results to parents.",
    icon: "faFileAlt",
    actions: [
      {
        title: "1. 📝 Create New Exam (Basic & Advanced Settings)",
        type: "success",
        steps: [
          "📂 From the sidebar, select 'Exams'.",
          "➕ Click the 'Create New Exam' button (+ icon) at the top left of the screen to begin.",
          "✍️ In the popup window, enter the 'Exam Title' and a short description.",
          "🏫 Select the 'Class' from the dropdown menu.",
          "[IMG]" + exam_manager_3,
          "📅 Set the 'Exam Start Date and Time' and ensure it is correct.",
          "⏱️ Enter the 'Exam Duration in Minutes'.",
          "⚖️ Define the default 'Question Weight' that will be applied to the questions.",
          "⚙️ Advanced Settings: You can enable 'Randomize Questions' to prevent cheating, and enable 'Use Draft' so the student can write notes during the exam.",
          "💾 Click 'Save'. The exam will appear in the list with a 'Pending' or 'Incomplete' status."
        ],
        warning: "⚠️ Make sure to set the exam duration and question weight carefully, as this will directly affect the student's final evaluation."
      },
      {
        title: "2. ❓ Manage Exam Questions",
        type: "info",
        steps: [
          "📋 In the exams list, click on the exam name or the 'Details' button to enter the question management screen.",
          "➕ Click 'Add New Question' and select the question type (Multiple Choice, Text, etc.).",
          "✍️ Write the question text, add the possible options, and select the correct answer.",
          "[IMG]" + exam_manager_2,
          "✅ Once you finish adding all questions, review the total marks to ensure they match your plan."
        ]
      },
      {
        title: "3. ▶️ Start, Stop, or Reset Exam",
        type: "warning",
        steps: [
          "▶️ To start the exam: Find the exam and click the 'Start Exam' button (▶️ icon). The exam will become available to students.",
          "[IMG]" + exam_manager_4,
          "⏹️ To stop the exam: Click the 'Stop' button (⏹️ icon). No new student will be able to enter, and the answers of active students will be submitted.",
          "🔄 To reset: Click the 'Reset' button (🔄 icon). A warning message will appear confirming the deletion of all attempts."
        ],
        warning: "🚨 Resetting the exam (Reset) clears all student answers and grades recorded for this exam. Use this option with extreme caution!"
      },
      {
        title: "4. 👤 Assign Exam to Specific Student",
        type: "success",
        steps: [
          "👥 If you want only a specific student to take the exam, click the 'Assign' icon next to the exam.",
          "🪟 A popup window will appear containing a list of your students.",
          "🔍 Search for the student's name, select them, then click 'Confirm Assignment'.",
          "🔒 This exam will now only be visible to the assigned student."
        ]
      },
      {
        title: "5. ✈️ Send Results to Parents",
        type: "info",
        steps: [
          "📊 After the exam finishes and is graded, you can send the results directly to the parents.",
          "✈️ Click the 'Send to Parents' icon (paper plane ✈️).",
          "[IMG]" + exam_manager_5,
          "📱 Notifications and/or SMS messages will be sent to the students' parents with their results."
        ]
      },
      {
        title: "6. 🖨️ Print Paper Exam",
        type: "info",
        steps: [
          "📄 If you prefer conducting a paper exam, the platform provides a direct printing option.",
          "🖨️ Click the 'Print' icon (🖨️) next to the desired exam.",
          "📑 The system will generate a print-ready file containing all questions properly formatted.",
          "[IMG]" + exam_manager_6
        ]
      },
      {
        title: "7. 📈 Track Student Status (Completed & Incomplete)",
        type: "info",
        steps: [
          "📊 In the list, you can click on the statistics icons to view quick lists.",
          "✅ Students who completed the exam: Displays a list of students who finished the exam and had their grades recorded.",
          "⏳ Absent students: Displays a list of students who have not entered the exam, allowing you to contact them."
        ]
      },
      {
        title: "8. 🗑️ Delete Exam",
        type: "danger",
        steps: [
          "🗑️ If you want to permanently delete an exam, click the red 'Delete' icon.",
          "⚠️ A warning confirmation message will appear to verify your deletion request.",
          "✅ Click 'Confirm Deletion'."
        ],
        warning: "🚨 The exam and its results cannot be recovered after confirming the deletion. Please be completely sure before taking this action."
      }
    ],
    screenshotId: exam_manager_1
  },
  {
    id: "course_management",
    title: "Course Management",
    description: "A comprehensive section for creating and editing training courses, managing videos, tracking student subscriptions, and reviewing enrollment requests.",
    icon: "faBook",
    actions: [
      {
        title: "1. 📚 Create New Course",
        type: "success",
        steps: [
          "📁 From the sidebar, select 'Courses'.",
          "➕ Click the 'Add New Course' button (+ icon) at the top left of the screen.",
          "✍️ Fill in the basic course details: Course name, description, price, and discount percentage (if any).",
          "🏫 Select the Category and Material from the dropdown menus.",
          "🎓 Specify whether the course is 'Certified' or not.",
          "🖼️ Upload a distinctive 'Cover Image' for the course to attract students.",
          "💾 Click 'Save'. Once saved, the course will appear in the courses grid."
        ]
      },
      {
        title: "2. 🎥 Course Video Management & Uploading",
        type: "info",
        steps: [
          "🎥 In the courses grid, find your course and click its 'Video' icon to open the Course Video Manager.",
          "📑 You will find two tabs: 'Video Library' to view current videos, and 'Upload New Videos'.",
          "☁️ To upload a new video: Go to the upload tab, enter the video description, and select or drop video files (up to 500MB each).",
          "➕ You can upload multiple videos simultaneously by clicking 'Add Another Video'.",
          "✋ Drag & Drop Reordering: In the Video Library, drag any video card using its drag handle to reorder the lesson sequence for students, then click 'Save Order'.",
          "[IMG]" + course_2,
          "📼 In the 'Video Library': Watch uploaded videos, check total storage size, and access full management controls for each video."
        ]
      },
      {
        title: "3. ❓ Interactive Questions & Video Quizzes",
        type: "success",
        steps: [
          "➕ Add Interactive Question: Click the (+) icon on any video card to attach a question that pops up automatically for students at a specific timestamp (in seconds).",
          "🎯 Enter the question text, explanation, 4 choices, select the correct answer, and set the question score.",
          "📋 View & Manage Video Quizzes: Click the list icon to view, edit, or delete all interactive questions associated with the video."
        ]
      },
      {
        title: "4. 📎 Video Attachments & Documents",
        type: "info",
        steps: [
          "📎 Add Attachment: Click the paperclip icon to upload supplementary materials (PDF summaries, Word documents, images) for the video.",
          "📂 View & Manage Attachments: Click the folder icon to browse all attached documents, download them, or remove them."
        ]
      },
      {
        title: "5. 🔄 Edit Video Description & Replace Video File",
        type: "warning",
        steps: [
          "✏️ Edit Video Description: Click the edit pencil icon to update the video title or formatted description anytime.",
          "🔄 Update Video File: Click the sync icon to replace an existing video file with a new version without losing its attached questions or materials.",
          "🗑️ Delete Video: Click the red trash icon to permanently remove the video after confirmation."
        ]
      },
      {
        title: "6. 👁️ Show/Hide Course (Visibility)",
        type: "warning",
        steps: [
          "👁️‍🗨️ You can control the course visibility for students.",
          "👁️ Click the 'Eye' icon next to the course to temporarily hide or unhide it.",
          "🚫 Hidden courses will not appear in the course store for students."
        ]
      },
      {
        title: "7. 🧮 Recalculate Course Hours",
        type: "info",
        steps: [
          "⏳ If you added or removed videos from the course, you can update the total recorded hours.",
          "🧮 Click the 'Recalculate Hours' button on the course card.",
          "✅ The system will automatically update the total time and display it to students."
        ]
      },
      {
        title: "8. 👥 Manage Subscriptions & Enrollment Requests",
        type: "success",
        steps: [
          "📑 Use the top tabs to switch between 'Courses', 'Subscriptions', and 'Enrollment Requests'.",
          "💳 In the 'Subscriptions' section: You can see the students currently subscribed to your courses and manage their subscriptions.",
          "📬 In the 'Enrollment Requests' section: You can review requests from students who want to join a specific course and approve or reject them."
        ]
      },
      {
        title: "9. ✏️ Edit or Delete Course",
        type: "danger",
        steps: [
          "✏️ To edit course details: Click the 'Edit' icon, update the data (like price or description), and save the changes.",
          "🗑️ To delete the course: Click the red 'Delete' icon.",
          "⚠️ A warning window will appear to confirm the deletion. Be sure of your decision as deletion is permanent."
        ],
        warning: "🚨 Deleting the course will result in the complete loss of its content. It is recommended to use the 'Hide' feature instead of deleting if there are active students."
      }
    ],
    screenshotId: course_1
  },
  {
    id: "blog_management",
    title: "Blog Management",
    description: "A comprehensive section for adding, editing, and deleting educational articles on the platform with search and categorization capabilities.",
    icon: "faBlog",
    actions: [
      {
        title: "1. 📝 Add New Article",
        type: "success",
        steps: [
          "📰 From the sidebar, go to 'Blog'.",
          "➕ Click the 'Add New Article' button at the top left of the screen.",
          "📂 Select the 'Category' for the article from the dropdown menu.",
          "✍️ Enter the 'Article Title' and a 'Short Description'.",
          "📄 Write the full article content in the 'Content' field using the rich text editor.",
          "🖼️ Upload an 'Article Image' to attract students' attention.",
          "🚀 Click 'Save'. The article will be published immediately and visible to students in the blog section."
        ]
      },
      {
        title: "2. 🔍 Search and Browse Articles",
        type: "info",
        steps: [
          "📋 The articles table displays all the articles you have published.",
          "🔍 You can use the search bar to find a specific article by its title.",
          "📄 You can browse through different pages using the pagination buttons at the bottom of the table."
        ]
      },
      {
        title: "3. 🗑️ Edit or Delete Article",
        type: "danger",
        steps: [
          "✏️ To edit an article: Click the 'Edit' icon next to the article, update its data, and save.",
          "🗑️ To delete an article: Click the red 'Delete' icon.",
          "⚠️ A confirmation window will ask if you are sure about the deletion. Click 'Confirm' to erase the article."
        ],
        warning: "🚨 Deleting an article is a permanent action and it will be removed from the platform forever."
      }
    ],
    screenshotId: blog_1
  },
  {
    id: "student_management",
    title: "Student Management",
    description: "The comprehensive section for adding students, editing their data, and tracking their status and accounts on the platform.",
    icon: "faUsers",
    actions: [
      {
        title: "1. 👨‍🎓 Add New Student to Platform",
        type: "success",
        steps: [
          "👥 From the sidebar, select 'Students'.",
          "➕ Click the 'Add New Student' button at the top left of the screen.",
          "✍️ Fill in the student's details: Full name, email, class, and subject.",
          "⚧️ Choose the 'Gender' (Male/Female) and enter the 'Phone Number' (must start with 01 and be 11 digits).",
          "🔑 Enter the 'Password' for the student, and you may optionally upload a profile picture.",
          "[IMG]" + student_2,
          "✅ Click 'Add Student'. The student's account will be activated immediately."
        ]
      },
      {
        title: "2. 🔍 Search and Browse Students List",
        type: "info",
        steps: [
          "📋 The students table displays all your registered students with their basic data (Name, Email, Phone, Password).",
          "🔎 You can use the search bar to find any student using their name or phone number.",
          "👁️ You can show or hide the student's password by clicking the eye icon next to the password."
        ]
      },
      {
        title: "3. 🔗 Share Student Credentials",
        type: "info",
        steps: [
          "🔗 To share the student's login credentials, click the 'Share' icon next to the student's name.",
          "[IMG]" + student_3,
          "📋 A formatted message containing the username, password, and other details will be copied, which you can send directly to the student."
        ]
      },
      {
        title: "4. 🚫 Activate or Suspend Student Account",
        type: "warning",
        steps: [
          "🛑 You can prevent a specific student from accessing their account without deleting them completely.",
          "👤 Click the status icon (Activate/Suspend) next to the student.",
          "🔒 If you suspend the account, the student will not be able to log in until you activate it again."
        ]
      },
      {
        title: "5. ✏️ Edit or Delete Student Data",
        type: "danger",
        steps: [
          "✏️ To edit data: Click the 'Edit' icon and update any information (like changing the password or phone number).",
          "[IMG]" + student_4,
          "🗑️ To delete a student: Click the red 'Delete' icon.",
          "⚠️ Alert: Deleting a student will permanently erase all their data, results, and subscriptions."
        ],
        warning: "🚨 Use the 'Suspend Account' feature instead of deletion if you wish to retain the student's data and past results."
      },
      {
        title: "6. 🤖 Student Details and Smart Analysis (Rafeeq AI)",
        type: "success",
        steps: [
          "👁️ In the students table, click the 'Details' icon next to any student to enter their personal page.",
          "🪪 The page will display the student's ID card with all their academic and basic data.",
          "🤖 At the bottom of the screen, you will find the 'Robot' icon for the smart assistant (Rafeeq AI). Click it.",
          "[IMG]" + student_5,
          "📊 Agree to generate the analysis, and the system will generate a comprehensive smart report of the student's exam performance.",
          "📲 Once the report appears, you can click the 'Send Report to Parent' button to send it via WhatsApp with one click."
        ]
      }
    ],
    screenshotId: student_1
  },
  {
    id: "mozakara_management",
    title: "Mozakara Management (Study Materials)",
    description: "Upload and share study materials (PDF files) with students, and easily manage past materials.",
    icon: "faBookOpen",
    actions: [
      {
        title: "1. 📤 Upload New Material",
        type: "success",
        steps: [
          "📚 Go to the 'Mozakara' section from the sidebar.",
          "➕ Click the 'Add Material' button at the top left of the screen.",
          "✍️ Enter the material's title and a short description.",
          "🏫 Select the class and subject to which the material belongs.",
          "📄 Upload the material files (preferably PDF format) and add a thumbnail cover image.",
          "[IMG]" + mozakara_1,
          "💾 Click 'Save' to make the material instantly available to enrolled students."
        ]
      },
      {
        title: "2. 🔍 Browse and Manage Current Materials",
        type: "info",
        steps: [
          "📋 In the materials management screen, the table displays all previously uploaded materials.",
          "📊 The table shows details for each material: Title, Class, Subject, Number of attached files, and Creation date.",
          "[IMG]" + mozakara_2,
          "🔎 You can use the search bar to quickly find a specific material."
        ]
      },
      {
        title: "3. ✏️ Edit or Delete Material",
        type: "danger",
        steps: [
          "✏️ To edit data: Click the 'Edit' icon to update the attachments or basic data of the material.",
          "🗑️ To delete material: Click the red 'Delete' icon to permanently remove it from the platform.",
          "⚠️ A confirmation message will appear before deletion, make sure of your decision as deletion cannot be undone."
        ],
        warning: "🚨 Important Alert: When deleting the material, all files and attachments associated with it will be permanently deleted."
      }
    ],
    screenshotId: mozakara_2
  },
  {
    id: "reports",
    title: "Reports & Analytics",
    description: "A comprehensive dashboard to track student performance, analyze exam results, and extract detailed reports to make data-driven decisions.",
    icon: "faChartLine",
    actions: [
      {
        title: "1. 📊 General Statistics and Charts",
        type: "info",
        steps: [
          "📈 From the sidebar, select 'Reports' to access the dashboard.",
          "💳 At the top of the screen, you will find cards summarizing overall performance: total exams, number of students, average scores, and completion rate.",
          "🍩 The pie chart displays the percentage of passing versus failing students.",
          "📊 The bar chart illustrates the top-performing students, and the line chart shows the growth of student numbers monthly.",
          "[IMG]" + report_1
        ]
      },
      {
        title: "2. 📋 Exam Reports and Data Export",
        type: "success",
        steps: [
          "📜 In the 'Exam Reports' section, you can see details of each exam individually.",
          "👀 The table displays: Exam name, Date, Number of students, Average scores, and Completion rate.",
          "📥 Click the 'Export Exams Report' button to download data in CSV or Excel format for sharing or archiving.",
          "[IMG]" + report_2
        ]
      },
      {
        title: "3. 👨‍🎓 Comprehensive Student Performance Reports",
        type: "warning",
        steps: [
          "🧑‍🏫 At the bottom of the screen, there is a dedicated table for detailed student reports.",
          "📊 The table displays statistics for each student: number of exams taken, average scores, completion rate, and continuous improvement rate.",
          "📥 You can also export the full student report in CSV format with one click on the 'Export Student Report' button.",
          "[IMG]" + report_3
        ]
      }
    ],
    screenshotId: report_1
  },
  {
    id: "settings",
    title: "General Settings",
    description: "Adjust preferences for the teacher account and exams to have full control over the educational process with ease.",
    icon: "faCog",
    actions: [
      {
        title: "1. ⚙️ Exam Settings",
        type: "info",
        steps: [
          "🛠️ Go to 'Settings' from the sidebar to access the available control options.",
          "💯 Default Passing Score: You can set a percentage (e.g., 50%) to be considered as the default passing score for any new exam you create.",
          "📱 Mobile Devices: Enable or disable this option to allow students to take exams via their mobile phones.",
          "🏆 Honor Board Exams Count: Determine the number of exams required for a student to be ranked and added to the honor board based on their excellence."
        ]
      },
      {
        title: "2. 💾 Save Changes",
        type: "success",
        steps: [
          "💡 The 'Save Changes' button will become active once you modify any of the previous settings.",
          "💾 Click 'Save Changes' at the top of the screen to apply the new modifications to the system immediately.",
          "ℹ️ Note: Changes made here will be automatically applied as default settings for all future exams."
        ]
      }
    ],
    screenshotId: setting_1
  },
  {
    id: "profile",
    title: "Profile",
    description: "Review and update teacher data, and easily track account status and subscriptions.",
    icon: "faUser",
    actions: [
      {
        title: "1. 👁️ Review Account Data",
        type: "info",
        steps: [
          "🖼️ Through the main profile screen, you can see your profile picture, name, and qualification.",
          "💳 The side section displays the account status (Verified and Active) as well as your subscription details and remaining days in the current package.",
          "🔒 Through the 'Security and Privacy' tab, you can view guidelines to protect your account.",
          "[IMG]" + profile_1
        ]
      },
      {
        title: "2. ✏️ Edit and Update Personal Data",
        type: "warning",
        steps: [
          "⚙️ Click the 'Edit Profile' button in the left side section to enter edit mode.",
          "📸 To change your picture, click the camera icon that will appear over your current picture and select a new image from your device.",
          "📝 In the 'Basic Information' tab, update your name, email, and academic qualification.",
          "🔑 To change the password, go to the 'Security and Privacy' tab and enter the new password (or leave the field blank if you do not wish to change it).",
          "[IMG]" + profile_2,
          "💾 Once finished, click the green 'Save' button to securely update your data."
        ]
      }
    ],
    screenshotId: profile_1
  }
];

export const teacherDocsData = { ar, en };
